export const sliceIntoChunks = (arr, chunkSize) => {
    const res: any[] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}; 